import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {

  constructor(private router: Router) { }

  ngOnInit(): void {
  }

  // gotoCLEPortal() {
  //   this.router.navigate(['/cle']);
  // }

  gotoEFile() {
    console.log('Go to eFile')
    this.router.navigate(['/ogc']);
  }
}
